import React from 'react';
import { Center, Flex, Group, Loader, Paper, Pill, Text, Tooltip } from '@mantine/core';
import classes from './Chat.module.css';
import { TablerIcon } from '@tabler/icons-react';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';

type Props = {
  Icon: TablerIcon;
  title: string;
  description: string;
  isPreview?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
};

export default function Suggestion({
  title,
  description,
  isPreview = false,
  isLoading = false,
  Icon,
  onClick = () => {},
}: Props) {

  const handleOnClick = () => {
    Mixpanel.track(MixpanelEvents.SIESTA_SUGGESTION_REQUESTED, { suggestion: title, enabled: !isPreview });
    if(!isPreview) {
      onClick()
    }
  }

  return (
    <Tooltip
      label={
        <>
          <Group>
            <Text fw={600}>{title}</Text>
            {isPreview && <Pill size={'xs'}>Coming soon!</Pill>}
          </Group>

          <Text size={'sm'}>{description}</Text>
        </>
      }
      multiline
      w={320}
      withArrow
      position={'left'}
      color={'black'}
    >
      <Flex
        direction={'row'}
        px={'sm'}
        gap={'sm'}
        onClick={handleOnClick}
        style={{ cursor: 'pointer' }}
        align={'center'}
      >
        <Paper
          bg={'gray.1'}
          radius={'sm'}
          withBorder={true}
          className={classes.icon}
        >
          <Center h={'100%'}>
            {isLoading ? <Loader size={'xs'} /> : <Icon stroke={1} size={20} />}
          </Center>
        </Paper>

        <Text span size={'md'} fw={500}>
          {title}
        </Text>
      </Flex>
    </Tooltip>
  );
}
